(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-selector"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const selectorElement = document.querySelector('.affiliate-selector');
  const apiKey = selectorElement.getAttribute('data-api-key');
  const groupId = selectorElement.getAttribute('data-group-id');
    const groupId2 = selectorElement.getAttribute('data-group-id2');
  loadAffiliates(apiKey, groupId,groupId2);

  document.getElementById('setAffiliateButton').addEventListener('click', setAffiliate);
  displaySelectedAffiliate();
});

function loadAffiliates(apiKey, groupId,groupId2) {
  const fields = 'ref_code,name,city,group_id,group_id2';
  fetch(`https://api.goaffpro.com/v1/admin/affiliates?fields=${fields}`, {
    headers: {
      'x-goaffpro-access-token': apiKey
    }
  })
  .then(response => {
    if (!response.ok) {
      console.error('Network response was not ok', response.statusText);
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    return response.json();
  })
  .then(data => {
    const affiliateDropdown = document.getElementById('affiliateDropdown');
    data.affiliates.forEach(affiliate => {
      if (affiliate.group_id == groupId) {
        console.log(affiliate);
        const name = affiliate.name || 'Unknown Company';
        const city = affiliate.city || 'Unknown City';
        const option = document.createElement('option');
        option.value = affiliate.ref_code;
        option.textContent = `${name}, ${city}`;
        affiliateDropdown.appendChild(option);
      }
          /*if (affiliate.group_id == groupId2) {
        console.log(affiliate);
        const name = affiliate.name || 'Unknown Company';
        const city = affiliate.city || 'Unknown City';
        const option = document.createElement('option');
        option.value = affiliate.ref_code;
        option.textContent = `${name}, ${city}`;
        affiliateDropdown.appendChild(option);
      }*/
    });
  })
  .catch(error => console.error('Error fetching affiliates:', error));
}

function setAffiliate() {
  const selectedAffiliateRefCode = document.getElementById('affiliateDropdown').value;
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('ref', selectedAffiliateRefCode);
  window.location.href = currentUrl.toString();
}
  function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


function displaySelectedAffiliate() {
  const refCode = getCookie('ref');
  if (refCode) {
    const apiKey = document.querySelector('.affiliate-selector').getAttribute('data-api-key');
    fetch(`https://api.goaffpro.com/v1/admin/affiliates?fields=ref_code,name,city&ref_code=${refCode}`, {
      headers: {
        'x-goaffpro-access-token': apiKey
      }
    })
    .then(response => response.json())
    .then(data => {
      const affiliate = data.affiliates.find(affiliate => affiliate.ref_code === refCode);
      if (affiliate) {
        const name = affiliate.name || 'Unknown Company';
        const city = affiliate.city || 'Unknown City';
        document.getElementById('selectedAffiliate').innerText = `You are currently Supporting: ${name}, ${city}`;
      }
    })
    .catch(error => console.error('Error fetching selected affiliate:', error));
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
